export default {
  above_threshold: "above threshold",
  accept: "accept",
  action_type: "action type",
  actions: "actions",
  active: "active",
  activity_type: "activity type",
  actual_completion_date: "actual completion date",
  actual_completion_date_desc: "Populated when a Finance user marks the payout as completed, capturing the exact completion timestamp.",
  add: "add",
  add_a_comment: "add a comment",
  add_a_parameter: "add a parameter",
  add_album: "add album",
  add_all: "add all",
  add_comment: "add comment",
  add_featured_performer: "add featured performer",
  add_fee: "add fee",
  add_filter: "add filter",
  add_first_maker: "add first maker",
  add_new_parameter: "add new parameter",
  add_non_featured_performer: "add non-featured performer",
  add_ownership: "add ownership",
  added_at: "added at",
  added_by: "added by",
  additional_details: "additional details",
  advanced_search: "advanced search",
  affected_payments_by_effective_date: "affected payments by effective date",
  agent: "agent",
  aggregated: "aggregated",
  album: "album",
  album_names: "album names",
  albums: "albums",
  alerts: "alerts",
  aliases: "aliases",
  all: "all",
  all_except: "all except",
  all_member_collectives: "all member collectives",
  amount: "amount",
  amount_gross: "gross amount",
  amount_net_delta: "Delta Net Amount",
  amount_payable: "payable amount",
  amount_raw: "raw amount",
  amount_total_delta: "Delta Total Amount",
  answered_by: "answered by",
  any: "any",
  anyone: "anyone",
  anyone_but_my_mc: "Anyone but my MC",
  apply: "apply",
  apply_effective_date: "apply effective date",
  approve: "approve",
  approve_merge: "approve merge",
  approve_transactional_removal: "approve transaction removal",
  approved: "approved",
  artist: "artist",
  artist_prefix: "artist prefix",
  at: "at",
  auto_manually_matched: "auto manually matched",
  automatched: "automatched",
  automatched_count: "automatched count",
  automatic: "automatic",
  available_balance_maker: "available balance maker",
  available_balance_performer: "available balance performer",
  back: "back",
  backup_eligibility_scheme: "backup eligibility scheme",
  base_fees: "base fees",
  batch: "batch",
  batch_id: "Batch ID",
  batch_id_desc: "A 6-character alphanumeric identifier that tracks transactions in progress, ensures each payout batch is unique, and records the history of removed transactions. It helps identify and manage payouts that are currently in progress.",
  broadcast_end: "broadcast end",
  broadcast_start: "broadcast start",
  broadcaster_id: "broadcaster ID",
  broadcaster_name: "broadcaster name",
  broadcasters: "broadcasters",
  by: "by",
  by_distribution: "by distribution",
  by_transaction: "by transaction",
  calculate_vpp: "VPP calculation method",
  calculate_withholding: "calculate withtholding",
  calculation_time: "completion time",
  canada: "canada",
  canada_and: "Canada and",
  cancel: "cancel",
  cancel_payout: "cancel payout",
  cancel_create_fee: "Are you sure you want to cancel creating this Fee? Any unsaved progress will be lost",
  cancel_create_tariff_period: "Are you sure you want to cancel creating this Tariff period? Any unsaved progress will be lost",
  cancel_create_payout: "Are you sure you want to cancel creating this Payout? Any unsaved progress will be lost",
  cancel_edit_tariff_period: "Are you sure you want to cancel you changes? Any unsaved changes will be lost.",
  cancelled: "cancelled",
  candidates: "candidates",
  category: "category",
  challenge: "challenge",
  challenge_match: "challenge match",
  challenge_owner: "challenge linked owner",
  challenge_pending: "challenge pending",
  challenge_performer: "challenge linked performer",
  challenge_source_metadata: "challenge linked metadata",
  challenge_without_recording: "create a challenge without a suggested recording",
  challenge_without_rs_id: "Challenge Without Re:Sound ID",
  challenged: "challenged",
  challenged_by: "challenged by",
  challenged_on: "challenged on",
  challenges: "challenges",
  challenges_pending: "challenges pending",
  child_recordings_to_merge: "child recording(s) to merge",
  choose_vpp_method: "Choose the method for creating VPP",
  choose_vpp_method_help_text: "manual will allow the user to put a value on this screen, automatic will let the system calculate an automatic value based on the revenue pool",
  citizenship: "citizenship",
  claims: "claims",
  code: "code",
  cof: "cof",
  collapse_all: "collapse all",
  collective: "collective",
  collective_society: "Collective/Society",
  collectives: "collectives",
  college: "college",
  college_type: "college type",
  college_help_text: "this will determine the type of rights holder for which the system will generate transactions",
  comment: "comment",
  comment_created_successfully: "Comment created successfully",
  comment_deleted_successfully: "Comment deleted successfully",
  comment_edited_successfully: "Comment edited successfully",
  comment_without_recording: "create a comment without a suggested recording",
  comments: "comments",
  common: "common",
  compact_view: "compact view",
  compare_performers: "compare performers",
  complete: "complete",
  completed: "completed",
  composer: "composer",
  composers: "composers",
  confirm: "confirm",
  confirm_the_match: "confirm the match",
  conflict: "conflict",
  conflicted_ipn: "conflicting IPN",
  conflicted_isrc: "conflicting ISRC",
  conflicts: "conflicts",
  connect_one_time: "CONNECT One Time Payment",
  connect_open: "CONNECT Open",
  connect_reproduction: "CONNECT",
  connect_track_specific: "CONNECT Track Specific",
  consolidated_metadata: "consolidated metadata",
  consolidated_share_details: "consolidated share details",
  consolidated_usages: "consolidated usages",
  contact_admin: "please contact an administrator",
  contact_service_desk: "contact service desk",
  copy: "copy",
  copy_role: "copy role",
  copyright: "copyright",
  copyrights: "copyrights",
  copyrights_and_tariffs: "copyrights and tariffs",
  core_data: "core data",
  core_metadata: "core metadata",
  count: "count",
  countries: "countries",
  country: "country",
  country_help_text: "country where this tariff period applies",
  country_of_fixation: "country of fixation",
  country_of_residency: "Country of Residency",
  create: "create",
  create_fee: "create fee",
  create_hold: "create hold",
  create_merge_request: "create merge request",
  create_new_payout: "create new payout",
  create_new_sr: "Create new SR",
  create_new_tariff_period: "create new tariff period",
  create_payout: "create payout",
  create_rightsholder: "Create rightsholder",
  create_role: "create user role",
  create_tariff_period: "create tariff period",
  create_tariff_period_confirm: "Are you sure you want to create the tariff/period?",
  created: "created",
  created_by: "created by",
  created_by_desc: "Identifies the user who created the payout, using the Crescendo user's first name, last name, and username for accurate tracking.",
  created_on: "created on",
  created_successfully: "created successfully",
  crescendo_help: "crescendo help",
  crescendo_id: "crescendo ID",
  crescendo_system: "Crescendo System",
  csv: "csv",
  currency: "currency",
  current: "current",
  current_matched_recording: "current matched recording",
  cusma: "cusma",
  custom: "custom",
  da_agent: "DA Agent",
  da_name: "DA Name",
  da_type: "DA Type",
  database: "database",
  date: "date",
  date_bought: "date bought",
  date_end: "date end",
  date_from: "date from",
  date_of_birth: "date of birth",
  date_of_death: "date of death",
  date_of_merge: "date of merge",
  date_range: "date range",
  date_sold: "date sold",
  date_start: "date start",
  date_to: "date to",
  default: "default",
  default_split: "default split",
  delete: "delete",
  delete_comment: "delete comment",
  delete_hold: "delete hold",
  delete_hold_confirm: "are you sure you want to delete this hold?",
  delete_tariff_period: "delete tariff period",
  delete_user: "delete user",
  deleted: "deleted",
  delta: "delta",
  deny: "deny",
  deny_transaction_removal: "deny transaction removal",
  depending_of_how_big_the_repertoire_is: "depending of how big the repertoire is, the export process can take a while",
  depending_of_how_big_the_report_is: "depending of how big the report is, the export process can take a while",
  description: "description",
  detailed_stats: "detailed statistics",
  details: "details",
  different_type: "different type",
  direct_assignor: "direct assignor",
  direct_assignors: "direct assignors",
  dis: "dis",
  display_all_users: "Display all Users",
  display_by: "display by",
  display_by_group: "Display by group",
  distributed: "distributed",
  distribution: "distribution",
  distribution_date: "distribution date",
  distribution_hold: "distribution hold",
  distribution_methodology: "distribution methodology",
  distribution_methodology_and_eligibility: "distribution methodology and eligibility",
  distribution_methodology_help_text: "defaulted to standard usage based. This determines the internal logic the system will follow for calculating transactions, adjustments and eligibility parameters",
  distribution_period: "distribution period",
  do_you_really_want_to_delete_comment: "do you really want to delete this comment",
  do_you_really_want_to_delete_tariff_period: "do you really want to delete this tariff period",
  do_you_really_want_to_delete_user: "do you really want to delete this user",
  do_you_really_want_to_invalidate_file: "do you really want to invalidate this repertoire file",
  do_you_really_want_to_invalidate_shares: "do you really want to invalidate this shares",
  do_you_really_want_to_link_this_maker: "do you really want to link this maker",
  do_you_really_want_to_link_this_performer: "do you really want to link this performer",
  do_you_really_want_to_link_this_recording: "do you really want to link this recording",
  do_you_really_want_to_unmatch_usage: "do you really want to unmatch this usage",
  do_you_want_to_launch_rematching_process: "do you want to launch the rematching process",
  domestic: "domestic",
  done: "done",
  dont_have_financial_interest: "without financial interest",
  download: "download",
  download_template: "download template",
  drill_down: "drill down",
  duplicated_conflicts: "Duplicated ISRCs & IPNs",
  duplicated_conflicts_ipn: "Duplicated IPNs",
  duplicated_conflicts_isrc: "Duplicated ISRC",
  duplicated_performer: "duplicated performer in different categories",
  dur: "dur.",
  duration: "duration",
  edit: "edit",
  edit_details: "edit details",
  edit_fee: "edit fee",
  edit_role: "edit user role",
  edit_tariff_period: "edit tariff period",
  edit_tariff_period_confirm: "Are you sure you want to save these changes?",
  effective_calendar_end: "effective calendar end",
  effective_calendar_end_date: "eff. calendar end",
  effective_calendar_start: "effective calendar start",
  effective_calendar_start_date: "eff. calendar start",
  effective_date: "effective date",
  eligibility: "eligibility",
  eligibility_conflict: "eligibility conflict",
  eligibility_conflicts: "eligibility conflicts",
  eligibility_data: "eligibility data",
  eligibility_end_date: "eligibility end date",
  eligibility_metadata: "eligibility metadata",
  eligibility_parameter: "eligibility parameter",
  eligibility_scheme: "eligibility scheme",
  eligibility_start_date: "eligibility start date",
  eligible: "eligible",
  email: "email",
  end_date: "end date",
  end_date_should_be_greater_or_equal: "End date should be greater or equal to start date",
  endpoint: "endpoint",
  enter_name_or_description: "enter a name or description",
  enter_tariff: "enter the tariff for this Tariff Period",
  error: "error",
  error_occurred: "an error occurred, please contact an administrator",
  error_type: "error type",
  error_updating_user: "error updating user",
  errors: "errors",
  estimated_completion_date: "estimated completion date",
  estimated_track_value: "estimated track value",
  excel: "excel",
  except: "except",
  except_placeholder: "Choose the options you want to exclude",
  exchange_rate: "exchange rate",
  execute: "execute",
  execute_transaction_refreshes: "You are about to execute all pending transaction refresh requests in the queue. This action cannot be undone. Do you want to proceed?",
  execute_transaction_removals: "You are about to execute all approved transaction removal requests in the queue. This action cannot be undone. Do you want to proceed?",
  execution_date: "execution date",
  expand_all: "expand all",
  expand_all_sources: "expand all sources",
  export: "export",
  export_ownership_conflicts: "export ownership conflicts",
  export_repertoire: "export repertoire",
  export_repertoire_for_ss: "export repertoire for sister society",
  export_tariff_period_list: "export tariff period list",
  export_transactions_list: "export transactions list",
  export_unclaimed_recordings: "export unclaimed recodings",
  export_usages: "export usages",
  exported_file_will_contain_unique_recordings: "exported file will contain unique recordings, and will have less results than shown on screen when multiple consolidated usages are matched to the same recording.",
  external: "external",
  failed: "failed",
  feature: "feature",
  featured: "featured",
  featured_and_non_featured: "featured and non-featured",
  fee_creation_cancelled: "Fee creation process has been canceled. No Fee was created",
  featured_count: "Featured Count",
  female: "female",
  field: "field",
  file: "file",
  filename: "filename",
  files_exceed_the_rows_limitation: "files exceed the 200,000 rows limitation of the Excel file format",
  fill_in_the_missing_fields: "please fill in all the required information before submitting",
  filter_by_action: "filter by action",
  filter_by_collective_society: "Filter by Collective/Society",
  filter_by_role: "Filter by Role",
  filter_by_sister_society: "Filter by Collective/Society",
  filter_by_state: "filter by state",
  filters: "filters",
  financial_actions: "financial actions",
  first_maker: "first maker",
  first_maker_nationality: "first maker nationality",
  first_makers: "first makers",
  first_makers_nationalities: "first makers nationalities",
  fixation_country: "fixation country",
  fixation_year: "fixation year",
  fm_nationality: "FM Nationality",
  fmn: "fmn",
  for: "for",
  form_contains_errors: "form contains errors",
  format_file: "format file",
  from_maker_source: "Data from maker source or migrated from OPUS",
  from_role: "from role",
  gender: "gender",
  general: "general",
  general_details: "general details",
  general_rejection: "General Rejection",
  generate_report: "generate report",
  genre: "genre",
  genre_conflict: "Genre Conflict",
  genre_conflict_pending: "genre conflict pending",
  genre_type: "Genre Type",
  go_back: "go back",
  go_to: "go to",
  gross: "gross",
  gross_amount: "gross amount",
  has_an_agent: "has an agent",
  has_candidates: "has candidates",
  has_financial_interest: "has financial interest",
  has_owners: "has owners",
  has_performers: "has performers",
  have_financial_interest: "with financial interest",
  help_guide: "help guide",
  hide_invalidated: "hide invalidated",
  hide_without_mandates: "hide without mandates",
  highlight_differences: "highlight differences",
  history: "history",
  hold: "hold",
  hold_help_text: "whether any of the colleges (or both) should have their payments held currently",
  hold_reason: "hold reason",
  hotkeys: "hotkeys",
  iconography: "iconography",
  id: "ID",
  id_proprietary_id: "ID / Proprietary ID",
  id_resound_id: "ID / Resound ID",
  import: "import",
  in: "in",
  in_progress: "in progress",
  in_review: "in review",
  inactive: "inactive",
  include_closeouts: "include closeouts",
  include_placeholder: "Choose specific options you want to include",
  include_specific: "include specific",
  incompatible_types_to_merge: "selected recording has incompatible types to merge",
  inconsistent_genres: "different genres provided in different sources",
  inconsistent_number_of_performers: "inconsistent number of performers provided in different sources",
  indirect_mc: "Indirect MC",
  information: "information",
  informational: "informational",
  ingested: "ingested",
  ingested_count: "ingested count",
  ingested_on: "ingested on",
  ingestion_error: "ingestion error",
  ingestion_error_message: "file ingestion encountered an error:",
  ingestion_stats: "ingestion stats",
  initial_status: "Initial status",
  inline_error: "error occurred",
  inline_success: "successfully matched",
  input: "input",
  internal: "internal",
  internal_or_external: "internal or external",
  international: "international",
  international_incoming: "international incoming",
  invalidate: "invalidate",
  invalidate_file: "invalidate file",
  invalidate_shares: "invalidate shares",
  invalidated: "invalidated",
  invalidation_effective_date: "invalidation effective date",
  invoice: "invoice",
  invoice_number: "invoice number",
  ipn: "IPN",
  is_junk: "is junk",
  is_not_junk: "is not junk",
  isrc: "ISRC",
  issues_found_in_section: "issues found. Please review and correct the errors.",
  item: "item",
  items: "items",
  items_per_page: "items per page",
  junk: "junk",
  junk_history: "junk history",
  junk_status: "junk status",
  junked_usage: "junked usage",
  keep: "keep",
  landed: "landed",
  landing_recording: "landing recording",
  last_calculation: "last calculation run",
  latest_review: "latest review",
  launch_rematch_process: "landed",
  lead_role: "team lead user role",
  level: "level",
  lineup_adjustments: "lineup adjustments",
  lineup_conflict: "line-up conflict",
  lineup_conflict_playcount: "Lineup Conflict Playcount",
  lineup_conflict_playcount_percentage: "Lineup Conflict Playcount %",
  lineup_conflict_playcount_percentage_delta: "Lineup Conflict Playcount delta %",
  lineup_conflict_recordings: "Lineup Conflict Recordings",
  lineup_conflict_recordings_percentage: "Lineup Conflict Recordings %",
  lineup_conflict_recordings_percentage_delta: "Lineup Conflict Recordings delta %",
  lineup_conflict_title: "Lineup Conflict",
  link_maker: "link maker",
  link_performer: "link performer",
  link_recording: "link recording",
  linked: "linked",
  linked_with_master: "linked with the master",
  load_all_transactions: "Load All Transactions",
  load_transactions: "load transactions",
  lock_featured: "lock featured",
  lock_non_featured: "lock non-featured",
  log_format: "log format",
  loss_of_mandate:"Loss of Mandate",
  main_details: "main details",
  main_performers: "main performers",
  make_comment: "make a comment",
  maker: "maker",
  maker_and_performer: "maker and performer",
  maker_manual_matching: "maker manual matching",
  maker_matching_challenge: "maker matching challenge",
  maker_name: "maker name",
  maker_open_period_end_date_help_text: "open period end date will be set automatically to 4 years after the end date of the tariff period",
  maker_vpp: "Maker VPP",
  makers: "makers",
  male: "male",
  managed_by: "managed by",
  mandate: "mandate",
  mandate_conflict: "mandate conflict",
  mandate_conflict_pending: "mandate conflict pending",
  mandate_conflict_playcount: "Mandate Conflict Playcount",
  mandate_conflict_playcount_percentage: "Mandate Conflict Playcount %",
  mandate_conflict_playcount_percentage_delta: "Mandate Conflict Playcount delta %",
  mandate_conflict_recordings: "Mandate Conflict Recordings",
  mandate_conflict_recordings_percentage: "Mandate Conflict Recordings %",
  mandate_conflict_recordings_percentage_delta: "Mandate Conflict Recordings delta %",
  mandate_file: "mandate file",
  mandates: "mandates",
  manual: "manual",
  manual_matching: "manual matching",
  manual_submissions: "manual submissions",
  manually_created: "manually created",
  manually_linked: "manually linked",
  manually_matched: "manually matched",
  manually_matched_count: "manually matched count",
  mark_as: "mark as",
  mark_as_junk: "mark as junk",
  mark_as_not_junk: "mark as not junk",
  marked_as: "marked as",
  match: "Match",
  match_date: "match date",
  match_sr: "Match Recording",
  matched: "matched",
  matched_by: "matched by",
  matched_maker: "Matched - Maker",
  matched_on: "matched on",
  matched_performer: "Matched - Performer",
  matched_playcount: "matched playcount",
  matched_playcount_delta: "Matched Playcount delta",
  matched_playcount_delta_percent: "matched playcount delta %",
  matched_playcount_percent: "matched playcount %",
  matched_playcount_percentage: "Matched Playcount %",
  matched_playcount_percentage_delta: "Matched Playcount delta %",
  matched_status: "matched status",
  matched_to: "matched to",
  matching_conflict_pending: "matching conflict pending",
  matching_conflicts: "matching conflicts",
  matching_conflicts_down_key: "Select next conflict",
  matching_conflicts_question_key: "Show this dialog",
  matching_conflicts_r_key: "Refresh data on the page",
  matching_conflicts_up_key: "Select previous conflict",
  matching_date: "matching date",
  matching_stats: "matching Stats",
  matching_stats_export: "matching statistics export",
  matching_type: "matching type",
  mc: "member collective",
  mc_source: "member collective source",
  member_collective: "member collective",
  member_collectives: "member collectives",
  member_name: "member name",
  merge: "merge",
  merge_makers: "merge makers",
  merge_performers: "merge performers",
  merge_recordings: "merge recordings",
  merge_request_created: "merge request created successfully",
  merge_requests: "merge requests",
  merged_makers: "merged makers",
  merged_performers: "merged performers",
  merged_recordings: "merged recordings",
  merged_srs: "merged recordings",
  min_threshold: "minimum threshold",
  missing_featured_count: "missing featured count",
  missing_mandate: "missing mandate",
  missing_non_featured_count: "missing non featured count",
  modify_scope: "modify scope",
  modify_shares: "modify shares",
  moratorium: "moratorium",
  moratorium_applied_success: "Moratorium on the colleges: {colleges} for the {distribution} tariff period has been successfully placed.",
  moratorium_apply_text: "You are about to place a moratorium on the {distribution} tariff period. Please select the type of college from the dropdown before proceeding.",
  moratorium_minimum: "moratorium minimum",
  moratorium_remove_text: "You are about to remove the moratorium for the {distribution} tariff period. Please select the type of college from the dropdown before proceeding.",
  moratorium_removed_success: "Moratorium on the colleges: {colleges} for the {distribution} tariff period has been successfully removed.",
  more_performers_than_specified: "reconciling results in more performers in category than specified by the sources",
  more_resources: "more resources",
  multi_sorting_help_text: "Use Shift key to select multiple columns for sorting",
  music_master: "music master",
  music_video: "music video",
  must_be_a_decimal: "this field must be a decimal number",
  must_be_a_year: "the value must be a valid year",
  must_be_before_target: "this field must be after {_target_}",
  must_be_duration: "invalid duration (format mm:ss)",
  must_be_isrc: "Invalid ISRC (format CAK401400212)",
  must_be_less_than: "this field must be less than {max}",
  must_be_more_than: "This field must be more than {min}",
  must_be_positive: "this field must be a positive number",
  my_matches: "my matches",
  my_mc: "My MC",
  name: "name",
  nationalities: "nationalities",
  nationality: "nationality",
  negative_adjustment_resolved: "negative adjustment resolved",
  negative_adjustment_suggested: "negative adjustment suggested",
  negative_adjustments: "negative adjustments",
  net: "net",
  net_amount: "net amount",
  new_data: "new data",
  new_tariff_period: "new tariff/period",
  next: "next",
  next_calculation: "next calculation run",
  no: "no",
  no_access: "no access",
  no_access_featured: "You have no permission to review this recording's featured lineup",
  no_access_non_featured: "You have no permission to review this recording's non-featured lineup",
  no_changes_were_made: "No changes were made",
  no_continue_editing: "No, continue editing",
  no_filter: "no filter",
  no_genre_conflict: "No Genre Conflict",
  no_hold: "No Hold",
  no_lineup_conflict_title: "No Lineup Conflict",
  no_mandate_conflict: "No Mandate Conflict",
  no_mandates: "no active mandates",
  no_ownership_conflict: "No Ownership Conflict",
  no_performers_featured: "No featured Performers for this Recording yet",
  no_performers_non_featured: "No non-featured Performers for this Recording yet",
  no_permissions_ownership: "You have no permission to review this recording's ownership information",
  no_proxy: "No proxy",
  no_stations: "No stations for this Broadcaster yet",
  non_eligible_playcount: "Non-Eligible Playcount",
  non_eligible_playcount_percentage: "Non-Eligible Playcount %",
  non_eligible_playcount_percentage_delta: "Non-Eligible Playcount delta %",
  non_eligible_recordings: "Non Eligible Recordings",
  non_eligible_recordings_percentage: "Non Eligible Recordings %",
  non_eligible_recordings_percentage_delta: "Non Eligible Recordings delta %",
  non_feature: "non-feature",
  non_featured: "non-featured",
  non_featured_count: "Non-Featured Count",
  none: "none",
  not_enough_number_of_performers: "not enough number of performers",
  not_finished: "not finished",
  not_junk: "not junk",
  not_started: "not started",
  notes: "notes",
  notes_help_text: "use this field for writing any notes for users to read",
  notification_center: "notification center",
  nr: "nr",
  number_of_performers: "# of perfs",
  of: "of",
  official: "official",
  old_data: "old data",
  on: "on",
  on_hold: "On Hold",
  only_affected_rights_holders: "only affected rights holders",
  open_in_new_tab: "open in new tab",
  open_period: "open period",
  open_period_end_date: "open period end date",
  open_period_start_date: "open period start date",
  open_period_start_date_help_text: "open period start date will be set to the 1st day of the month following the end date of the tariff period",
  original_artist: "original artist",
  original_currency: "original currency",
  original_title: "original title",
  other: "other",
  owners: "owners",
  ownership: "ownership",
  ownership_adjustments: "ownership adjustments",
  ownership_conflict: "Ownership Conflict",
  ownership_conflict_playcount: "Ownership Conflict Playcount",
  ownership_conflict_playcount_percentage: "Ownership Conflict Playcount %",
  ownership_conflict_playcount_percentage_delta: "Ownership Conflict Playcount delta %",
  ownership_conflict_recordings: "Ownership Conflict Recordings",
  ownership_conflict_recordings_percentage: "Ownership Conflict Recordings %",
  ownership_conflict_recordings_percentage_delta: "Ownership Conflict Recordings delta %",
  ownership_conflicts: "ownership conflicts",
  page: "page",
  paid_amount_maker: "paid amount maker",
  paid_amount_performer: "paid amount performer",
  parameters: "parameters",
  parent_recording: "parent recording",
  parties: "parties",
  payability_checks: "pay-ability checks",
  payable: "payable",
  payable_amount: "payable amount",
  payable_amount_maker: "payable amount maker",
  payable_amount_performer: "payable amount performer",
  payable_playcount: "Payable Playcount",
  payable_playcount_percentage: "Payable Playcount %",
  payable_playcount_percentage_delta: "Payable Playcount delta %",
  payable_recordings: "payable recordings",
  payable_recordings_delta_percent: "payable recordings delta %",
  payable_recordings_percent: "payable recordings %",
  payee: "payee",
  payee_id: "Payee ID",
  payee_name: "Payee Name",
  payee_tariff: "Payee + Tariff Period",
  payee_type: "payee type",
  payees: "payees",
  payment_due: "payment due",
  payment_hold: "payment hold",
  payment_status: "payment status",
  payment_uploads: "payment uploads",
  payments: "payments",
  payout_creation_cancelled: "payout creation cancelled",
  payout: "payout",
  payout_id: "Payout ID#",
  payout_ID: "Payout ID",
  internal_payout_id: "Internal Payout ID",
  payout_failed: "Payout failed. Please contact administrator.",
  payout_id_desc: "Assigned to transactions upon payout completion and displayed on paid transactions. IDs increment sequentially (e.g., 1, 2, 3). If a payout in progress is canceled, the same ID will be reassigned to the next payout.",
  fees: "fees",
  payouts: "payouts",
  pc_maker: "PC Maker",
  pc_performer: "PC Performer",
  pending: "pending",
  pending_for_validation: "pending for validation",
  pending_maker_matching: "Pending Maker Match",
  pending_matches: "Pending matches",
  pending_performer_matching: "Pending Performer Match",
  pending_queue: "pending queue",
  pending_user_actions: "pending user actions",
  percentage: "percentage",
  performer: "performer",
  performer_id: "performer id",
  performer_in_both_categories: "same performer participates in both categories in sources",
  performer_lineups: "performer lineups",
  performer_manual_matching: "performer manual matching",
  performer_matching_challenge: "performer matching challenge",
  performer_name: "performer name",
  performer_open_period_end_date_help_text: "open period end date will be set to 6 years after the end date of the tariff period",
  performer_vpp: "Performer VPP",
  performers: "performers",
  performers_comparison: "performers comparison",
  performers_linked: "performers linked successfully",
  period: "period",
  period_description: "period descr.",
  period_end: "period end",
  period_end_date: "period end date",
  period_end_date_help_text: "end date should be later than the value entered for the period start date",
  period_start: "period start",
  period_start_date: "period start date",
  period_start_date_help_text: "date should be later than the previous tariff period's end date for the same tariff and should not overlap with the start and end date range of any other tariff periods for the same tariff",
  place_moratorium: "Place moratorium",
  placeholder: "placeholder",
  playcount: "playcount",
  playcounts_eligible: "eligible playcounts",
  playcounts_ineligible: "ineligible playcounts",
  playcounts_ineligible_help_text: "percentage of ineligible playcounts to be used for automatic VPP calculation",
  playcounts_ineligible_percentage_display: "Ineligible playcounts used of VPP calculation (%)",
  playcounts_ineligible_percentage_short: "Ineligible playcounts (%)",
  playcounts_ineligible_short: "Ineligible playcounts",
  playcounts_unmatched: "unmatched playcounts",
  playcounts_unmatched_help_text: "percentage of unmatched playcounts to be used for automatic VPP calculation",
  playcounts_unmatched_percentage_display: "Unmatched playcounts used of VPP calculation (%)",
  playcounts_unmatched_percentage_short: "Unmatched playcounts (%)",
  playcounts_unmatched_short: "Unmatched playcounts",
  playcounts_used_display: "Total number of playcounts used for calculation",
  playcounts_used_short: "Used playcounts",
  plays: "plays",
  please_pick_a_parent_maker: "please pick a parent maker",
  please_pick_a_parent_performer: "please pick a parent performer",
  please_pick_a_parent_recording: "please pick a parent recording",
  preview: "preview",
  preview_flag: "preview flag",
  previous: "previous",
  primary_eligibility_scheme: "primary eligibility scheme",
  primary_eligibility_scheme_help_text: "eligibility schemes define the rules to follow to determine if a transaction is eligible for payment or not",
  process_already_running: "process is already running",
  processing: "processing",
  processing_may_take_some_time: "processing may take some time",
  promoted: "promoted",
  proprietary_id: "Proprietary ID",
  proprietary_ids: "Proprietary IDs",
  province: "province",
  province_station_count: "province station count",
  provincial_population: "provincial population",
  proxy: "proxy",
  proxy_period_end_date: "proxy period end date",
  proxy_period_period_help_text: "proxy tariff start and end dates will determine the date range for usages that will apply to this tariff period",
  proxy_period_start_date: "proxy period start date",
  proxy_tariff: "proxy tariff",
  proxy_tariff_help_text: "if a proxy tariff is chosen, its related usages will be used for the transactions calculation",
  proxy_tariff_value_help_text: "chose the proxy tariff for this Tariff Period",
  raised_by: "raised by",
  raised_by_member_collective: "raised_by_member_collective",
  range_filter_empty_bound_description: "*leave empty to exclude",
  rank: "rank",
  rate: "rate",
  raw: "raw",
  ready: "ready",
  ready_for_sync: "ready for synchronization",
  real: "real",
  real_action: "real.",
  real_refunded_for_sync: "recording is marked as refunded for sync",
  real_released_for_sync: "recording is marked as released for sync",
  real_sync_status: "sync.",
  reason: "reason",
  rec: "rec",
  reconciled_lineup: "reconciled lineup",
  reconciliation_error: "reconciliation error",
  reconciliation_pending: "reconciliation pending",
  recording: "recording",
  recording_albums: "recording albums",
  recording_artist: "recording artist",
  recording_challenges_actions: "recording challenges",
  recording_eligibility_conflict_resolved: "recording eligibility conflict resolved",
  recording_id: "Recording ID",
  recording_isrc: "Recording ISRC",
  recording_matching_challenge: "recording matching challenge",
  recording_matching_stats: "Rec. Match. Stats",
  recording_matching_status: "recording matching status",
  recording_title: "recording title",
  recording_type: "recording type",
  recordings: "recordings",
  recordings_count: "recordings count",
  recordings_in_other_merge_requests: "highlighted recordings are already part of other merge request(s)",
  recordings_linked: "recordings merged successfully",
  recordings_merge_request_rejected: "merge rejected successfully",
  recordings_reconciliation_started: "recordings update has been started.",
  reference_information: "reference information",
  refresh: "refresh",
  refreshed: "refreshed",
  refresh_progress: "refresh in progress",
  refresh_failed: "refresh failed",
  refresh_jobs_fail: "failed to execute pending transaction refresh requests. Please contact administrator or try again.",
  refresh_jobs_success: "all pending transaction refresh requests have been successfully executed.",
  refresh_queued:"refresh queued",
  refresh_request: "refresh request",
  refresh_request_fail: "failed to create refresh request.",
  refresh_request_success: "refresh request has been successfully submitted.",
  refund_payment: "refund payment",
  refund_undistributed: "refund undistributed",
  reject_merge: "reject merge",
  release_payment: "release payment",
  release_year: "release year",
  released: "released",
  releases: "releases",
  rematch_usages: "rematch usages",
  rematching_launched: "rematch launched",
  removal: "removal",
  removal_denied: "Removal denied",
  removal_jobs_fail: "failed to execute pending transaction removal requests. Please contact administrator or try again.",
  removal_jobs_success: "all pending transaction removal requests have been successfully executed.",
  removal_progress: "removal in progress",
  removal_queued: "Removal queued",
  removal_request_fail: "failed to remove transaction. Please contact administrator or try again.",
  removal_request_success: "removal request has been successfully submitted and will be reviewed by a member of the Re:Sound team shortly.",
  removal_requested: "Removal requested",
  remove: "remove",
  remove_moratorium: "Remove moratorium",
  remove_transaction: "remove transaction",
  removed: "removed",
  removing_moratorium: "Removing moratorium",
  rep_track: "RepTrack",
  repertoire: "repertoire",
  repertoire_actions: "repertoire actions",
  repertoire_errors: "repertoire errors",
  repertoire_file: "repertoire file",
  repertoire_file_invalidated: "repertoire file invalidated successfully",
  repertoire_matching: "repertoire matching",
  report: "report",
  report_generated: "report generated",
  reporting: "reporting",
  representative: "representative",
  request_date: "request date",
  requested_on: "requested on",
  requester: "requester",
  requests: "requests",
  reserve: "reserve",
  reserve_help_text: "amount to subtract from the available pool as a reserve for this specific college",
  reset: "reset",
  reset_changes: "reset last action",
  reset_to_default: "reset to default",
  resolve: "resolve",
  resolved: "resolved",
  resolved_matches: "Resolved matches",
  resolved_on: "resolved on",
  resound_id: "Resound ID",
  result: "result",
  revenue: "revenue",
  revenue_currency: "revenue currency",
  revenue_currency_help_text: "Defaulted to CAD, this determines which currency the system uses to generate the transactions",
  revenue_help_text: "enter the collected revenue as a currency value",
  revenue_source_country: "revenue source country",
  revenue_total: "revenue total",
  review_date: "review date",
  review_history: "review history",
  reviewed: "reviewed",
  reviewed_by: "Reviewed by",
  reviewed_count: "reviewed count",
  reviewer: "reviewer",
  rh_id: "rh. id",
  rh_name: "RH. name",
  rig: "rig",
  rights_holder: "rightsholder",
  rights_holder_id: "Rights Holder ID",
  rights_holder_name: "Rights Holder Name",
  rights_holder_tariff_period: "Rights holder + Tariff Period",
  rights_holder_tariff_recording: "Rights holder + Tariff Period + Recording",
  rights_holder_title: "Rights Holder",
  rights_holder_type: "rightsholder type",
  rights_holders: "Rights Holders",
  rightsholder: "rightsholder",
  rightsholder_challenges: "rightsholder challenges",
  rightsholder_id: "rightsholder id",
  rightsholder_matching_stats: "Righ. Match. Stats",
  rightsholder_matching_status: "rightsholder matching status",
  rightsholder_name: "rightsholder name",
  rightsholder_type: "rightsholder type",
  rightsholders: "rightsholders",
  rightsholders_actions: "rightsholders actions",
  rightsholders_linked: "rightsholders linked successfully",
  role: "role",
  royalties: "royalties",
  royalties_paid: "royalties paid",
  royalty_details: "royalty details",
  salesforce_id: "Salesforce ID",
  same_type: "same type",
  save: "save",
  save_back: "save & back",
  save_changes: "save changes",
  saved_as_draft: "saved as draft",
  saved_changes: "changes were successfully saved",
  saved_changes_solved: "changes were successfully saved and the conflict was solved",
  scope: "scope",
  scoped: "scope set",
  search: "search",
  search_agent: "search agent",
  search_all_recordings: "search all recordings",
  search_for_a_maker: "search for a maker",
  search_maker: "search maker",
  search_other_candidates: "search other candidates",
  search_performer: "search performer",
  search_recording: "search recording",
  search_rightsholder: "search rightsholder",
  search_suggested_match_id: "Search Suggested Re:Sound ID",
  search_tariff_period: "search tariff period",
  search_user: "search user",
  searched_recordings: "searched recordings",
  secondary_eligibility_scheme: "secondary eligibility scheme",
  secondary_eligibility_scheme_help_text: "if primary eligibility scheme is found not eligible, the system will use this secondary eligibility scheme to define if the transaction is eligible or not",
  see_sr_history: "See SR's whole history",
  select_all: "select all",
  select_all_page: "select all in this page",
  select_copyrights: "select copyrights",
  select_countries: "select countries",
  select_country_of_fixation: "select country of fixation",
  select_date_range: "select date range",
  select_first_maker_nationalities: "select first maker nationalities",
  select_first_makers: "select first makers",
  select_mc: "select mc",
  select_member_collectives: "select member collectives",
  select_source_metadata: "select source metadata",
  select_stations: "select stations",
  select_status: "select status",
  select_tariffs: "select tariffs",
  selector: "selector",
  sent_for_sync: "Data was sent for sync",
  service_fees: "service fees",
  set_scope: "set scope",
  sf: "sf",
  share: "share",
  share_delta: "Delta Share",
  share_payee: "Payee Share",
  shared_repertoire_area: "shared repertoire area",
  shares_invalidated: "shares invalidated successfully",
  shares_modified: "shares modified successfully",
  show_all_types: "show all types",
  show_available_unmatch: "show available for unmatch only",
  show_by_file: "show by file",
  show_done: "show done",
  show_from_secondary_sources: "show from secondary sources",
  show_from_secondary_sources_help: "show performer conflicts from non-performer sources and maker conflicts from non-maker sources",
  show_history: "Show history",
  show_landing_data: "Show landing data",
  show_only_source_metadata_in_conflict: "show only source metadata in conflict",
  show_parent_data: "show parent recording data",
  show_rep_tracks: "Show RepTracks",
  show_resolved: "show resolved",
  show_same_type: "same type recordings",
  show_source_metadata: "show source metadata",
  show_system_challenges: "show system challenges",
  show_vpp_history: "Show VPP History",
  showing: "showing",
  simple_repertoire_export: "export filtered recordings",
  sister_society: "sister society",
  society: "society",
  solve: "solve",
  sound_exchange: "sound exchange",
  sound_recording: "sound recording",
  source: "source",
  source_file: "source file",
  source_isrc: "Source ISRC",
  source_metadata: "source metadata",
  source_name: "source name",
  source_proprietary_id: "Source Proprietary ID",
  sources: "sources",
  split: "split %",
  sr_history: "SR history",
  sr_id: "SR ID",
  sra: "sra",
  standard: "standard",
  standard_usage_based: "standard usage based",
  start_date: "start date",
  statement_generated: "statement generated",
  statement_period: "stat. period",
  station: "station",
  station_name: "station name",
  stations: "stations",
  statistics: "statistics",
  status: "status",
  success: "success",
  suggest_effective_date: "suggest effective date",
  suggested_effective_date: "suggested effective date",
  suggested_match_id: "Suggested Re:Sound ID",
  suggested_recordings: "suggested recordings",
  swap: "swap",
  sync_payments: "sync payments",
  system_users: "system users",
  tariff: "tariff",
  tariff_code: "tariff code",
  tariff_period: "tariff period",
  tariff_period_created: "new tariff/period has been created",
  tariff_period_creation_cancelled: "Tariff period creation process has been canceled. No Tariff period was created",
  tariff_period_edit_cancelled: "Changes have been successfully discarded.",
  tariff_period_id: "Tariff Period ID",
  tariff_period_title: "Tariff Period",
  tariff_periods: "tariff periods",
  tariff_period_year: "tariff period year",
  tariffs: "tariffs",
  tariffs_in_scope: "number of tariff periods in scope",
  tariffs_in_scope_desc: "Indicates the number of tariff periods included in the payout scope. Updates automatically based on the tariff periods selected during scope definition.",
  tariffs_included: "tariffs included in the payout",
  tariffs_included_desc: "Tariffs included in the payout, determined based on the selected tariff periods.",
  technical_documentation: "technical documentation",
  territories: "territories",
  territory: "territory",
  territory_of_incoming_royalties: "territory of incoming royalties",
  the_information_is_too_different_merge: "The information is too different. Please check this box to force the merge.",
  the_information_is_too_different_merge_request: "The information is too different. Please check this box to force the merge request.",
  this_field_is_required: "this field is required",
  this_field_must_be_a_valid_email: "this field must be a valid email",
  this_fields_confirmation_does_not_match: "this fields confirmation does not match",
  this_maker_is_not_in_the_candidates_list: "this maker is not in the candidates list",
  this_performer_is_not_in_the_candidates_list: "this performer is not in the candidates list",
  this_recording_is_not_in_the_candidates_list: "this recording is not in the candidates list",
  threshold: "threshold",
  threshold_reached: "threshold reached",
  title: "title",
  today: "today",
  total: "total",
  total_playcount: "Total Playcount",
  total_playcount_delta: "Playcount Delta",
  total_recordings: "total recordings",
  total_unique: "total unique",
  transaction_batch_id: "Transaction batch ID#",
  transaction_calculation_timestamp: "Transaction Calculation Timestamp",
  transaction_id: "Transaction ID",
  transaction_payout: "Transactions & Payouts",
  transactions: "transactions",
  transactions_count: "# of Transactions",
  transactions_select_filter_text: "No transactions loaded. Click the filter icon in the top right of your screen to apply filters and start viewing your data.",
  trigger_transactions: "trigger transactions calculation",
  triggered_transactions: "triggered transactions",
  triggered_transactions_confirmation_rh: "Are you sure you want to trigger the transactions calculation for all tariff periods related to this rights holder?",
  triggered_transactions_confirmation_sr: "Are you sure you want to trigger the transactions calculation for all tariff periods related to this recording?",
  triggered_transactions_correctly: "Transactions calculation was triggered correctly. The system will show updated transactions once calculation process has finished",
  type: "type",
  type_of_fee: "type of fee",
  type_of_right: "type of right",
  unclaimed_for: "unclaimed for",
  undo_create: "undo create",
  undo_match: "undo match",
  undone_error: "Couldn't undo action",
  undone_success: "Action undone successfully",
  unidentified_conflict: "Unidentified Conflict",
  unidentified_mandate_conflict: "Unidentified Mandate Conflict",
  unique_count: "unique count",
  unknown: "unknown",
  unlink_create_rightsholder: "Unlink and create a new rightsholder",
  unlink_create_sr: "Unlink and create a new SR",
  unlinked: "unlinked",
  unmatch_usage: "Unmatch this usage",
  unmatched: "unmatched",
  unmatched_count: "unmatched count",
  unrepresented: "unrepresented",
  update: "update",
  update_albums: "update albums",
  update_first_makers: "update first makers",
  upload_by: "upload by",
  upload_date: "upload date",
  upload_user: "upload user",
  uploaded_by: "uploaded by",
  uploaded_on: "uploaded on",
  uploader: "uploader",
  uploads: "uploads",
  usage: "usage",
  usage_adjustment: "usage adjustment",
  usage_adjustments: "usage adjustments",
  usage_challenge: "usage challenge",
  usage_challenge_actions: "usage challenges",
  usage_challenge_resolved: "usage challenge resolved",
  usage_challenge_unmatched: "usage challenge unmatched",
  usage_date_range: "usage date range",
  usage_end_date: "usage end date",
  usage_files: "usage files",
  usage_id: "Usage ID",
  usage_info: "usage information",
  usage_matching: "usage matching",
  usage_period: "usage period",
  usage_start_date: "usage start date",
  usage_year: "usage year",
  usages: "usages",
  usages_reviewed: "usages reviewed",
  usages_updated: "usages updated",
  use: "use",
  use_current_matched_recording: "use current matched recording",
  use_proxy_tariff: "use proxy tariff",
  use_suggested_recording: "use suggested recording",
  user: "user",
  user_action_has_been_solved: "the user action you were reviewing has been solved by another user or process",
  user_action_solved: "user action solved",
  user_actions: "user actions",
  user_id: "user id",
  user_management: "user management",
  user_name: "user name",
  user_role: "user role",
  user_roles: "user roles",
  users: "users",
  view_qa: "View QA",
  view_reprod_usages: "view reprod. usages",
  view_transactions: "view transactions",
  vpp: "VPP",
  vpp_amounts: "VPP amounts",
  vpp_delta: "VPP delta",
  vpp_help_text: "Value Per Play to apply for this specific college",
  vpp_history: "VPP History",
  vpp_maker: "VPP maker",
  vpp_maker_delta: "VPP maker delta",
  vpp_performer: "VPP performer",
  vpp_performer_delta: "VPP performer delta",
  vpp_type: "VPP type",
  vpp_type_help_text: "if placeholder, generated transactions will be marked as 'preview' while official will create payable transactions",
  waiting_for_sync: "waiting for synchronization",
  we_will_send_you_an_email_with_a_link: "we’ll send you an email with a link to download the report when the process is completed",
  weighted_playcount: "weighted playcount",
  weighted_playcount_short: "w. playcount",
  when: "when",
  with_candidates: "with candidates",
  with_comment: "with comment",
  with_financial_interest: "financial interest",
  withholding_tax: "withholding tax",
  witholding_rate: "withholding rate",
  witholding_taxes: "withholding taxes",
  without_candidates: "without candidates",
  word: "word",
  works_database: "works database",
  worldwide: "worldwide",
  worldwide_except: "worldwide except",
  wppt: "wppt",
  wrong_filters: "Provided filter values are not valid. Check search query syntax or contact administrator.",
  wrong_uuids_specified: "wrong uuids specified",
  wrote: "wrote",
  ww: "WW",
  ww_except: "WW except",
  year: "year",
  year_of_fixation: "year of fixation",
  year_of_release: "year of release",
  yes: "yes",
  yes_cancel_editing: "yes, cancel editing",
  yof: "yof",
  yor: "yor",
}
